import { Avatar, List, Space, Modal } from 'antd';
import React from 'react';
import { TeamOutlined, DollarOutlined } from '@ant-design/icons';
import disasterTraslations from '../core/data/disaster-translations.json';
import moment from 'moment';
import { getImageUrl } from '../core/images';

const IconText = ({ icon, text }) => (
  <Space>
    {React.createElement(icon)}
    {text}
  </Space>
);

const HistoricalDetails = ({ isOpen, onClose, regionData }) => {
  const data = regionData?.disasters.map((disaster) => {
    return {
      title: disasterTraslations[disaster.subGroup],
      description: moment(disaster.startDate).format("DD/MM/YYYY") || disaster.year,
      totalAffected: disaster.totalAffected || disaster.totalDeaths,
      totalDamages: disaster["totalDamages ('000 US$)"],
      avatar: getImageUrl(disaster.subGroup),
    }
  })

  const sortedData = data?.sort((a, b) => {
    if (moment(a.description, "DD/MM/YYYY").isBefore(b.description, "DD/MM/YYYY")) {
      return -1
    }
    if (moment(a.description, "DD/MM/YYYY").isAfter(b.description, "DD/MM/YYYY")) {
      return 1
    }
    return 0;
  })?.reverse();
  
  return (
    <Modal
      title={regionData?.details}
      open={isOpen}
      onCancel={onClose}
      onOk={onClose}
      cancelText="Cerrar"
      okButtonProps={{ style: { display: 'none' } }}
    >
      <List
        itemLayout="vertical"
        size="large"
        pagination={{
          onChange: (page) => {
            console.log(page);
          },
          pageSize: 4,
        }}
        dataSource={sortedData}
        renderItem={(item) => (
          <List.Item
            key={item.title}
            actions={[
              item.totalAffected ? <IconText
                icon={TeamOutlined}
                text={`Nº Afectados: ${item.totalAffected}`}
                key="list-vertical-affected"
              />: null,
              item.totalDamages ? <IconText
                icon={DollarOutlined}
                text={`Gasto en USD: ${item.totalDamages}`}
                key="list-vertical-damage"
              /> : null,
            ].filter(Boolean)}
          >
            <List.Item.Meta
              avatar={<Avatar src={item.avatar} size={50} />}
              title={<a href={item.href}>{item.title}</a>}
              description={item.description}
            />
          </List.Item>
        )}
      />
    </Modal>
  );
}
export default HistoricalDetails;